import type { ComponentProps, PropsWithChildren } from 'react'
import { cn } from '@cocoonspace/ui/lib/utils'
import { cva, type VariantProps } from 'class-variance-authority'

export interface HeaderIconProps
	extends VariantProps<typeof headerIconVariants>, ComponentProps<'div'> {}

const headerIconVariants = cva(
	'flex h-[74px] w-[74px] flex-col items-center justify-center rounded-full bg-card text-4xl text-primary',
	{
		defaultVariants: {},
		variants: {
			variant: {
				gray: 'bg-slate-100',
			},
		},
	},
)

export const HeaderIcon = ({
	className,
	variant,
	children,
}: PropsWithChildren<HeaderIconProps>) => {
	return (
		<div className={cn(headerIconVariants({ className, variant }))}>
			{children}
		</div>
	)
}
